// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ukgH3","list":"styles_list__fXEoV"};